import _ from 'underscore'
const NumberOfIntervals = 5

const correctFloat = (num, prec = 14) => {
  return num > 1e14 ? num : parseFloat(num.toPrecision(prec))
}

const normalizeTickInterval = (interval) => {
  let retInterval = interval

  // round to a tenfold of 0.1, 0.2, 0.25, 0.5, 1, 2, 2.5 or 5
  const magnitude = Math.pow(10, Math.floor(Math.log(interval) / Math.LN10))
  const normalized = interval / magnitude

  const multiples = [0.1, 0.2, 0.25, 0.5, 1, 2, 2.5, 5, 10]

  // normalize the interval to the nearest multiple
  for (let i = 0; i < multiples.length; i++) {
    retInterval = multiples[i]
    // only allow tick amounts smaller than natural
    if ((retInterval * magnitude >= interval) ||
          ((normalized <= (multiples[i] + (multiples[i + 1] || multiples[i])) / 2))
    ) {
      break
    }
  }

  retInterval = correctFloat(
    retInterval * (magnitude),
    -Math.round(Math.log(0.001) / Math.LN10)
  )

  return retInterval
}

const getRoundedrMinAndInterval = (min, max, tickInterval) => {
  const adjustedTickInterval = normalizeTickInterval(tickInterval)
  const roundedMin = correctFloat(Math.floor(min / adjustedTickInterval) * adjustedTickInterval)
  const roundedMax = correctFloat(Math.ceil(max / adjustedTickInterval) * adjustedTickInterval)

  if (Math.abs((roundedMax - roundedMin) / adjustedTickInterval) < 5) { // breaks the recursion when no of intervals less than or equal to 5
    return { roundedMin: Math.min(roundedMin, roundedMax), tickInterval: adjustedTickInterval }
  }

  return getRoundedrMinAndInterval(min, max, tickInterval * 1.1)
}

// axis Name is like y, y2, y3, y4, y5, y6, y7, y8
// if displayPartialIntrevalAtMax is true then increases the max range a little bit more than what actual max range to avoid cliping the line width at the top.
// adding fraction to number of intervals avoids displaying another tick label at the top as well.
export const setYaxisRangeBasedOnTracesVisibility = (allData, yaxis, axisName, displayPartialIntrevalAtMax = false) => {
  const yAxisValues = []

  _.filter(allData, d => d.yaxis === axisName && d.opacity !== 0).forEach(r => yAxisValues.push(..._.filter(r.y, (v) => _.isFinite(v))))

  if (!_.isEmpty(yAxisValues) && yaxis) {
    const rangemode = yaxis.rangemode
    const yaxisMin = rangemode === 'tozero' ? Math.min(...yAxisValues, 0) : Math.min(...yAxisValues)
    const yaxisMax = Math.max(...yAxisValues)

    updateYaxisRange(yaxis, yaxisMin, yaxisMax, displayPartialIntrevalAtMax)
  }
}

export const updateYaxisRangeOnZoomWithUniformIntervals = (yaxis, displayPartialIntrevalAtMax = false) => {
  if (yaxis?.range?.length === 2) {
    updateYaxisRange(yaxis, yaxis.range[0], yaxis.range[1], displayPartialIntrevalAtMax)
  }
}

const updateYaxisRange = (yaxis, yaxisMin, yaxisMax, displayPartialIntrevalAtMax) => {
  const numberOfIntervals = displayPartialIntrevalAtMax ? NumberOfIntervals + 0.1 : NumberOfIntervals

  const yaxisMinAndInterval = getRoundedrMinAndInterval(yaxisMin, yaxisMax, 0.1)
  const yaxisRoundedMax = yaxisMinAndInterval.roundedMin + ((numberOfIntervals - 1) * yaxisMinAndInterval.tickInterval)
  const yaxisRange = [yaxisMinAndInterval.roundedMin, yaxisRoundedMax]

  yaxis.range = yaxisRange
  yaxis.dtick = yaxisMinAndInterval.tickInterval
}
